export default {
    validationErrors: {
        required: 'This field is required',
        email: 'This email address is not valid',
        maxLength: 'Must be [max] characters or less',
        minLength: 'Must be at least [min] characters',
        requireChecked: 'This must be checked before you can continue',
    },
};
